import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/service/login.service';
import { metalUpgradeEasyConfig } from 'src/environments/environment';

@Component({
    selector: 'app-easy-metal-card-upgrade',
    template: '',
    standalone: false
})
export class EasyMetalCardUpgradeComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(async (params) => {
      const queryParams = [];

      const inApp = params['inApp'];

      if (inApp) {
        queryParams.push('inApp=true');
      }

      if (queryParams.length > 0) {
        metalUpgradeEasyConfig.redirectUri += '?' + queryParams.join('&');
      }
    });
  }

  ngOnInit(): void {
    this.loginService.login(metalUpgradeEasyConfig);
  }
}
